import { ClaimToRoleType } from "../../types/Role";
import { post } from "../../utils/axios-config";
import { ROLES_ADD_CLAIM } from "../../utils/constants";

export const addClaimToRole = async (data: ClaimToRoleType) => await post<ClaimToRoleType, string>(ROLES_ADD_CLAIM, data);